import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RevenueSnapshot {
  timeframe: 'daily' | 'weekly' | 'monthly';
  totalRevenue: number;
  percentageChange: number;
}

export interface RevenueSnapshotChartData {
  date: string;
  revenue: number;
  label: string;
}

export interface RevenueSnapshotResponse {
  revenueSnapshots: Array<RevenueSnapshot>;
  dataForChart: Array<RevenueSnapshotChartData>;
}

export const reportingRevenueSnapshotAPI = async (params: {
  timeframe: 'daily' | 'weekly' | 'monthly';
}) => {
  const response = await baseAPI.get<RevenueSnapshotResponse>(
    '/dashboard/revenue-snapshot',
    {
      params,
    },
  );
  return response.data;
};

export const useReportingRevenueSnapshot = (params: {
  timeframe: 'daily' | 'weekly' | 'monthly';
}) => {
  return useQuery({
    queryKey: [KEYS.REVENUE_SNAPSHOT, params],
    queryFn: () => reportingRevenueSnapshotAPI(params),
    enabled: !!params.timeframe,
  });
};
